import React from 'react'
import TimePicker from 'react-time-picker'

const Select = (props) => {
    return(
        <div className="form-group">
            <label htmlFor={props.name}> {props.title} </label>
            <select
              name={props.name}
              value={props.value}
              onChange={props.handleChange}
              >
              <option value="" disabled>{props.placeholder}</option>
              {props.options.map(option => {
                return (
                  <option
                    key={option}
                    value={option}
                    label={option}>{option}
                  </option>
                );
              })}
            </select>
      </div>)
}

export default class DelegateFormInstance extends React.Component{
 constructor(props) {
        super(props);
        this.state = {
                changesSaved: false,
                name: '',
                phone_number:'',
                arrival_type: '',
                arrival_location: '',
                arrival_date: '',
                arrival_time: '',
                arrival_reference: '',
                departure_location: '',
                departure_type: '',
                departure_date: '',
                departure_time: '',
                departure_reference: '',
                isExistingDelegate: false

            };
        if (props.isExistingDelegate===true){
            this.state = {
                name: props.delegate.full_name,
                arrival_type: props.delegate.arrival_type,
                arrival_location: props.delegate.arrival_location,
                arrival_date: props.delegate.arrival_date_for_browser,
                arrival_time: props.delegate.arrival_time_for_browser,
                arrival_reference: props.delegate.arrival_reference,
                departure_location: props.delegate.departure_location,
                departure_type: props.delegate.departure_type,
                departure_date: props.delegate.departure_date_for_browser,
                departure_time: props.delegate.departure_time_for_browser,
                departure_reference: props.delegate.departure_reference,
                phone_number: props.delegate.mobile,
                isExistingDelegate: props.isExistingDelegate
        }

        }


       this.handleNameChange = this.handleNameChange.bind(this);
       this.handlePhoneNumberChange = this.handlePhoneNumberChange.bind(this);
       this.handleArrivalTypeChange = this.handleArrivalTypeChange.bind(this);
       this.handleArrivalDateChange = this.handleArrivalDateChange.bind(this);
       this.handleArrivalTimeChange = this.handleArrivalTimeChange.bind(this);
       this.handleArrivalReferenceChange = this.handleArrivalReferenceChange.bind(this);
       this.handleDepartureTypeChange = this.handleDepartureTypeChange.bind(this);
       this.handleDepartureDateChange = this.handleDepartureDateChange.bind(this);
       this.handleDepartureTimeChange = this.handleDepartureTimeChange.bind(this);
       this.handleDepartureReferenceChange = this.handleDepartureReferenceChange.bind(this);
       this.handleArrivalLocationChange = this.handleArrivalLocationChange.bind(this);
       this.handleDepartureLocationChange = this.handleDepartureLocationChange.bind(this);
       this.handleSubmit = this.handleSubmit.bind(this);
    }


 componentWillReceiveProps(nextProps) {
        if (nextProps.delegate !== null && nextProps.delegate !== undefined) {
            this.setState({
                name: nextProps.delegate.full_name,
                arrival_type: nextProps.delegate.arrival_type,
                arrival_location: nextProps.delegate.arrival_location,
                arrival_date: nextProps.delegate.arrival_date_for_browser,
                arrival_time: nextProps.delegate.arrival_time_for_browser,
                arrival_reference: nextProps.delegate.arrival_reference,
                departure_location: nextProps.delegate.departure_location,
                departure_type: nextProps.delegate.departure_type,
                departure_date: nextProps.delegate.departure_date_for_browser,
                departure_time: nextProps.delegate.departure_time_for_browser,
                departure_reference: nextProps.delegate.departure_reference,
                phone_number: nextProps.delegate.mobile,
                isExistingDelegate: nextProps.isExistingDelegate

            });
          }
        else{
            console.log('got empty delegate skipping it!', nextProps)
            }
    }


  handleNameChange(event) {
    this.setState({name: event.target.value});
  }
  handlePhoneNumberChange(event) {
    this.setState({phone_number: event.target.value});
  }

    handleArrivalTypeChange(event) {
        this.setState({
            'arrival_type': event.target.value,
            'changesSaved': false
        });
    }

    handleArrivalLocationChange(event) {
        this.setState({
            'arrival_location': event.target.value,
            'changesSaved': false
        });
    }
    handleArrivalDateChange(event) {
        console.log('getting new date:', event, event.target.value);
         this.setState({
            'arrival_date': event.target.value,
            'changesSaved': false
        });
    }


    handleArrivalTimeChange(time) {
        this.setState({
            'arrival_time': time,
            'changesSaved': false

        });
    }

    handleArrivalReferenceChange(event) {
        this.setState({
            'arrival_reference': event.target.value,
            'changesSaved': false
        });
    }


    handleDepartureTypeChange(event) {
        this.setState({
            'departure_type': event.target.value,
            'changesSaved': false
        });
    }

    handleDepartureLocationChange(event) {
        this.setState({
            'departure_location': event.target.value,
            'changesSaved': false
        });
    }
    handleDepartureDateChange(event) {
        this.setState({
            'departure_date': event.target.value,
            'changesSaved': false
        });
    }


    handleDepartureTimeChange(time) {
        this.setState({
            'departure_time': time,
            'changesSaved': false

        });
    }

    handleDepartureReferenceChange(event) {
        this.setState({
            'departure_reference': event.target.value,
            'changesSaved': false
        });
    }





    handleSubmit(event) {
        let headers = {
                      'Accept': 'application/json, text/plain, */*',
                      'Content-Type': 'application/json',
                    };
        if (document.getElementsByName("csrfmiddlewaretoken").length > 0){
            headers['X-CSRFToken'] = document.getElementsByName("csrfmiddlewaretoken")[0].value
        }
        console.log('working with this props:', this.props);
        let body = {
            delegate: {
                name: this.state.name,
                arrival_type: this.state.arrival_type,
                arrival_location: this.state.arrival_location,
                arrival_date: this.state.arrival_date,
                arrival_time: this.state.arrival_time,
                arrival_reference: this.state.arrival_reference,
                departure_location: this.state.departure_location,
                departure_type: this.state.departure_type,
                departure_date: this.state.departure_date,
                departure_time: this.state.departure_time,
                departure_reference: this.state.departure_reference,
                mobile: this.state.phone_number,

            },
                isNew: !this.state.isExistingDelegate,
                bookingId : this.props.bookingIdsForBookedAccommodations[this.props.item.reference_number],
                referenceNumber:this.props.item.reference_number,
            };
        console.log('delegate!', this.props.delegate, this.props.delegate !== null, this.props.delegate !== undefined);
        if(this.props.delegate !== null && this.props.delegate !== undefined){
            body.delegate['delegateId'] = this.props.delegate.id;
        }

        console.log('submitting!', event);
                fetch('/api/event-accommodation/save-guest-details-for-booked-accommodation/',  {
                    method: 'POST',
                    headers:headers,
                    body: JSON.stringify(body)

                })
                 .then(response => {
                     if (response.ok) {
                         this.setState({'changesSaved': true});
                         return response;
                     } else {
                         response.json().then(data =>{
                             console.log(data);
                             alert(data.toSource());
                         })

                     }
                     // this catches only http connection errors no bad response codes this is why we did the response
                     //limbo above
                 }).catch( err => console.log('an errror ocurred' + err))
    };


  render() {
      let saveButtonText = '';
      if(this.state.isExistingDelegate){
          saveButtonText = 'Edit'
      }
      else{
          saveButtonText = 'Save'
      }
      if (this.state.changesSaved) {
          saveButtonText = 'Saved';
      }
    return (
        <div className="delegate-form-wrapper">
            <form onSubmit={this.handleSubmit}>
                <div className="flex-container">
                    <div className="normalFormInputWrapper">
                        Name:
                        <input className="delegate-form-input" type="text" value={this.state.name} placeholder="Name"
                               onChange={this.handleNameChange}/>
                    </div>
                    <div className="smallTextPlaceHolder"> <strong>Arrival:</strong></div>
                    <div className="normalFormInputWrapper">
                        Arrival Type:
                        <Select
                            name={'arrivalType'}
                            options={["Flight", "Train", "Bus", "Other"]}
                            key="arrivalTypeSelector"
                            value={this.state.arrival_type || ''}
                            placeholder={'Select Type'}
                            handleChange={this.handleArrivalTypeChange}
                        /></div>
                    <div className="normalFormInputWrapper">
                        Arrival Date:
                        <input type="date" key="arrivalDatePicker" value={this.state.arrival_date || ''}
                               onChange={this.handleArrivalDateChange}/>
                    </div>
                    <div className="normalFormInputWrapper">
                        Arrival Time:
                        <TimePicker
                          onChange={this.handleArrivalTimeChange}
                          value={this.state.arrival_time || ''}
                        />

                    </div>
                    <div className="normalFormInputWrapper">
                        Arrival Reference:
                        <input className="delegate-form-input" type="text" value={this.state.arrival_reference}
                               placeholder="Arrival Reference" onChange={this.handleArrivalReferenceChange}/>
                    </div>
                    <div className="normalFormInputWrapper"> Arrival Location:
                        <input className="delegate-form-input" type="text" value={this.state.arrival_location}
                               placeholder="Arrival Location" onChange={this.handleArrivalLocationChange}/></div>

                </div>
                <div className="flex-container">
                    <div className="normalFormInputWrapper"> Phone number:
                        <input className="delegate-form-input" type="text" value={this.state.phone_number}
                               placeholder="Phone Number" onChange={this.handlePhoneNumberChange}/></div>
                    <div className="smallTextPlaceHolder"><strong>Departure:</strong></div>
                    <div className="normalFormInputWrapper">
                        Departure Type:
                        <Select
                            name={'departureType'}
                            options={["Flight", "Train", "Bus", "Other"]}
                            key="departureTypeSelector"
                            value={this.state.departure_type || ''}
                            placeholder={'Select Type'}
                            handleChange={this.handleDepartureTypeChange}
                        /></div>
                    <div className="normalFormInputWrapper">
                        Departure Date:
                        <input type="date" key="departureDatePicker" value={this.state.departure_date || ''}
                               onChange={this.handleDepartureDateChange}/>
                    </div>
                    <div className="normalFormInputWrapper"> Departure Time:

                        <TimePicker
                          onChange={this.handleDepartureTimeChange}
                          value={this.state.departure_time || ''}
                        />
                    </div>

                    <div className="normalFormInputWrapper">
                        Departure Reference:
                        <input className="delegate-form-input" type="text" value={this.state.departure_reference}
                               placeholder="Departure Reference" onChange={this.handleDepartureReferenceChange}/>
                    </div>
                    <div className="normalFormInputWrapper">
                        Departure Location:
                        <input className="delegate-form-input" type="text" value={this.state.departure_location}
                               placeholder="Departure Location" onChange={this.handleDepartureLocationChange}/>
                    </div>
                    <div className="saveButtonPlaceHolder"><input className="btn btn--primary" style={{padding: "0px"}}
                                                                  onClick={this.handleSubmit} value={saveButtonText}/>
                    </div>

                </div>
            </form>
        </div>


    );
  }
  }


// WEBPACK FOOTER //
// ./src/components/DelegateFormInstance.js